export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <span className="text-xl font-heading font-bold text-primary-400">69视频</span>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                69视频为你整理香蕉视频、红桃视频、91视频、蜜桃视频等同类型品牌视频平台大全，聚合免费在线观看资源，涵盖高清电影、电视剧、综艺节目，满足你的视频观看需求。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-3">
                {[
                  { label: '最新快讯', href: '#updates' },
                  { label: '平台特色', href: '#features' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer no-underline"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">更多内容</h4>
              <ul className="space-y-3">
                {[
                  { label: '主题索引', href: '#index' },
                  { label: '话题标签', href: '#topics' },
                  { label: '热度榜单', href: '#ranking' },
                  { label: '用户口碑', href: '#comments' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer no-underline"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                诚邀优质视频平台加入合作，共建免费在线视频生态，为观众提供更丰富的观影选择。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-700/50">
            <p className="text-center text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 69视频 - 视频平台推荐大全。本站为平台目录导航，不存储任何视频内容。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}